import { createRouter, createWebHistory, type RouteRecordRaw } from 'vue-router'
import { useAuthorization } from '@/stores/AuthorizationStore'
import messages from '@/core/composable/useMessages'
const { accessNotification } = messages();

const routes: Array<RouteRecordRaw> = [
    {
        path: '',
        name: 'rechargeLayout',
        component: () => import("@/layouts/clientLayout.vue"),
        children: [
            {
                path: '',
                name: 'home',
                component: () => import('@/modules/Home/view/homeTemplate.vue'),
                meta: {
                    requireAuth: true
                }
            },
            {
                path: '/DashBoard/WSPortal',
                name: 'dashBoard',
                component: () => import('@/modules/dashBoard/view/dashBoard.vue'),
                meta: {
                    requireAuth: true
                }
            },
            {
                path: '/ApiWebServices/SearchAccount',
                name: 'consultas',
                component: () => import('@/modules/consultas/view/consultasTemplate.vue'),
                meta: {
                    requireAuth: true
                }
            },

            {
                path: '/ApiWebServices/NewAccount',
                name: 'income',
                component: () => import('@/modules/income/view/incomeTemplate.vue'),
                meta: {
                    requireAuth: true
                }
            },
            {
                path: '/ApiWebServices/UpdateAccount',
                name: 'UpdateAccount',
                component: () => import('@/modules/updateAccount/view/updateAccountTemplate.vue'),
                meta: {
                    requireAuth: true
                }
            },

            {
                path: '/ApiWebServices/ChangeNip',
                name: 'changeNip',
                component: () => import('@/modules/changeNip/view/ChangeNipTemplate.vue'),
                meta: {
                    requireAuth: true
                }
            },

            {
                path: '/ApiWebServices/History',
                name: 'history',
                component: () => import('@/modules/history/view/historyTemplate.vue'),
                meta: {
                    requireAuth: true
                }
            },
            
            {
                path: '/ApiWebServices/DeactivateAccount',
                name: 'egress',
                component: () => import('@/modules/egress/view/egressTemplate.vue'),
                meta: {
                    requireAuth: true
                }
            },
            
            {
                path: '/ApiWebServices/Reactivate-Account',
                name: 'reEntry',
                component: () => import('@/modules/reEntry/view/readmisionsTemplate.vue'),
                meta: {
                    requireAuth: true
                }
            },
            
            {
                path: '/ApiWebServices/SearchAdvanced',
                name: 'searchAdvanced',
                component: () => import('@/modules/searchAdvanced/view/searchAdvanced.vue'),
                meta: {
                    requireAuth: true
                }
            },
            
            {
                path: '/ApiWebServices/Transfer',
                name: 'transfer',
                component: () => import('@/modules/transfer/view/transferTemplate.vue'),
                meta: {
                    requireAuth: true
                }
            },
            
            {
                path: '/ApiWebServices/TrackerTransacction',
                name: 'tracker',
                component: () => import('@/modules/trackerTransacction/view/trackerTransacction.vue'),
                meta: {
                    requireAuth: true
                }
            },
            
            {
                path: '/ApiIVR/ChangeNip/Activity',
                name: 'ivrChangeNip',
                component: () => import('@/modules/ivrChangeNip/view/changeNipActivity.vue'),
                meta: {
                    requireAuth: true
                }
            },
            
            {
                path: '/ApiIVR/ChangeNip/Reports',
                name: 'ivrReportTabs',
                component: () => import('@/modules/ivrChangeNip/view/reportsTab.vue'),
                meta: {
                    requireAuth: true
                }
            },
            
             {
                path: '/ApiIVR/WhiteList/Reports',
                name: 'ivrReportTabsWL',
                component: () => import('@/modules/ivrWhiteList/view/reportsTab.vue'),
                meta: {
                    requireAuth: true
                }
            },
            
            {
                path: '/ApiIVR/WhiteList/Activity',
                name: 'ivrWhiteList',
                component: () => import('@/modules/ivrWhiteList/view/whiteListActivity.vue'),
                meta: {
                    requireAuth: true
                }
            },
            
            {
                path: '/ApiCesispe/Generales',
                name: 'generalesPPL',
                component: () => import('@/modules/cesispe/view/generales/generalesList.vue'),
                meta: {
                    requireAuth: true
                }
            },
            
            {
                path: '/ApiCesispe/Egresos',
                name: 'egresosPPL',
                component: () => import('@/modules/cesispe/view/egresos/egresosList.vue'),
                meta: {
                    requireAuth: true
                }
            },
            
            {
                path: '/ApiCesispe/Traslados',
                name: 'trasladosPPL',
                component: () => import('@/modules/cesispe/view/traslados/transfersSearchForm.vue'),
                meta: {
                    requireAuth: true
                }
            },
            
            {
                path: '/ApiCesispe/transactionsPPL',
                name: 'transactionsPPL',
                component: () => import('@/modules/transactionPPL/view/listTransaction.vue'),
                meta: {
                    requireAuth: true
                }
            },
            
            {
                path: '/Tool/Monitor',
                name: 'Monitor',
                component: () => import('@/modules/monitor/view/monitorTemplate.vue'),
                meta: {
                    requireAuth: true
                }
            },
            

        ]
    },

    {
        path: '',
        component: () => import("../layouts/BlankLayout.vue"),
        children: [
            {
                path: '/Auth/Login',
                name: 'authLogin',
                component: () => import('@/modules/authLogin/loginTemplate.vue'),
                meta: {
                    requireAuth: false
                }
            },
            {
                path: '/:catchAll(.*)',
                name: 'NotFound',
                component: () => import('@/core/pagesErrors/404Template.vue'),
                meta: {
                    requireAuth: false
                }
            },
            {
                path: '/error',
                name: 'ServerError',
                component: () => import('@/core/pagesErrors/500Template.vue'),
                meta: {
                    requireAuth: false
                }
            }
        ]
    },

]

const router = createRouter({ history: createWebHistory(), routes })

router.beforeEach((to, from, next) => {
    const auth = useAuthorization();
    const isAuth = auth.statusLogin
    const isDash = auth.statusAlertDash
    
    if (to.meta.requireAuth && !isAuth) {
            next('/Auth/Login');
        } else {
            if (isDash!=null && isDash==false) {
                const promesa = accessNotification("error", "Restricted access: more permissions required.");
                if (promesa instanceof Promise) {
                    promesa.then(response => {
                        if (response) {
                            if (auth.getStatusLogin == false) {
                                next('home'); 
                            }
                        }
                    });
                }            
            } else {
                next(); // Permite el acceso a la ruta
            }
        }
})
export default router